
  
  
  
  




  var fechaInicio = new Date('2025-01-20T00:00');
  var fechaFin = new Date('2025-01-20T23:59');

  var htmlElement = document.querySelector('html'); 
  var langValue = htmlElement.getAttribute('lang');
  
  var counterAnnoucementBar = document.getElementById("shopify-section-announcement-bar");
  var blueMondayDiscounts = document.querySelectorAll("_discountBlueMonday");
  var normalDiscounts = document.querySelectorAll("_normalBubblueDiscount");
  var blueMondayMessage = document.getElementById("_idMessageBlueMonday");

  function mostrarOcultarContenido() {
  var ahora = new Date();

  if (ahora >= fechaInicio && ahora <= fechaFin && langValue == 'es') {
  
    counterAnnoucementBar.style.display = "block";
    /*blueMondayDiscounts.forEach(function(blueMondayDiscount, index, array) {
      blueMondayDiscount.style.display = "block";
    });
    normalDiscounts.forEach(function(normalDiscount, index, array) {
      normalDiscount.style.display = "none";
    });*/
    
    if(blueMondayMessage){
      blueMondayMessage.style.display = "block";
    }
  } 
}

  mostrarOcultarContenido();



    
